import { c as _c } from "react/compiler-runtime";
import { DetailsQuestionsInterface } from 'modules/calendar/bookings/types/booking-details-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { useOnceTrue } from 'shared/hooks/use-once-true';
import useSWR from 'swr';
interface UseBookingDetailsQuestionsProps {
  bookingId: number;
  opened?: boolean;
}
export const useBookingDetailsQuestions = t0 => {
  const $ = _c(6);
  const {
    bookingId,
    opened
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  const allowed = useOnceTrue(!!opened);
  let t2;
  if ($[1] !== allowed || $[2] !== bookingId) {
    t2 = () => {
      if (!allowed) {
        return;
      }
      return `/api/dashboard/editor/opt-in/surveys/${bookingId}`;
    };
    $[1] = allowed;
    $[2] = bookingId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    data
  } = useSWR(t2, fetcher);
  let t3;
  if ($[4] !== data) {
    t3 = {
      questions: data
    };
    $[4] = data;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};